<template>
  <div>
    <!-- TODO: Necesita refactorización y unificación de componentes por parte de Front, se ha creado subtarea -->
    <vt-side-panel
      v-if="showSidePanel"
      :visible="showSidePanel"
    >
      <study-request-detail
        v-if="selectedStudyRequest"
        :study-request="selectedStudyRequest"
        :cas-id="reqCasId"
        :show-case-report="true"
      >
        <b-button
          v-if="hasLabOperationGlobalMixin(selectedStudyRequest.laboratory.labId, requestOperation.CREATE)"
          id="createRequest"
          slot="buttons-end"
          v-tooltip="$t('hoverBtn.createRequest')"
          class="btn__icon btn__icon--primary px-2 py-0"
          variant="primary"
          @click="createRequest(selectedStudyRequest.patient.id)"
        >
          <i
            class="far fa-plus"
            aria-hidden="true"
          />
        </b-button>
        <b-button
          v-if="selectedStudyRequest.status.code === REQUEST_STATES.DRAFT.code && hasLabOperationGlobalMixin(selectedStudyRequest.laboratory.labId, requestOperation.CREATE)"
          id="editRequest"
          slot="buttons-end"
          class="btn__icon btn__icon--primary px-2 py-0"
          variant="primary"
          @click="editRequest(selectedStudyRequest.laboratory.labId, selectedStudyRequest.id)"
        >
          <i
            v-tooltip="$t('hoverBtn.editRequest')"
            class="far fa-pen"
            aria-hidden="true"
          />
        </b-button>

        <b-button
          v-if="selectedStudyRequest.status.code === REQUEST_STATES.REQUESTED.code && hasLabOperationGlobalMixin(selectedStudyRequest.laboratory.labId, requestOperation.PETITIONER_CANCEL)"
          id="cancelRequest"
          slot="buttons-end"
          class="btn__icon btn__icon--primary px-2 py-0"
          :disabled="selectedStudyRequest.status.code !== REQUEST_STATES.REQUESTED.code"
          variant="primary"
          @click="cancelRequestConfirmation([selectedStudyRequest])"
        >
          <i
            v-tooltip="$t('hoverBtn.cancelRequest')"
            class="far fa-ban"
            aria-hidden="true"
          />
        </b-button>

        <b-button
          v-if="selectedStudyRequest.status.code === REQUEST_STATES.DRAFT.code && hasLabOperationGlobalMixin(selectedStudyRequest.laboratory.labId, requestOperation.CREATE)"
          id="deleteRequest"
          slot="buttons-end"
          class="btn__icon btn__icon--primary px-2 py-0"
          variant="primary"
          @click="deleteDraftRequestConfirmation([selectedStudyRequest])"
        >
          <i
            v-tooltip="$t('component.studyRequest.form.discardDraft')"
            class="far fa-trash-alt"
            aria-hidden="true"
          />
        </b-button>

        <b-button
          v-if="hideBtn"
          id="attachToRequest"
          slot="buttons-end"
          class="btn__icon btn__icon--primary px-2 py-0"
          :disabled="![REQUEST_STATES.DRAFT.code, REQUEST_STATES.REQUESTED.code].includes(selectedStudyRequest.status.code)"
          variant="primary"
          @click="showAddFileModal(selectedStudyRequest)"
        >
          <i
            v-tooltip="$t('hoverBtn.attach')"
            class="far fa-paperclip"
            aria-hidden="true"
          />
        </b-button>

        <b-button
          v-if="printEnabled && selectedStudyRequest.status.code !== REQUEST_STATES.DRAFT.code
            && hasLabOperationGlobalMixin(selectedStudyRequest.laboratory.labId, requestOperation.PRINT_REQUEST_AND_LABELS)"
          id="requestFormRequest"
          slot="buttons-end"
          class="btn__icon btn__icon--primary px-2 py-0"
          variant="primary"
          @click="printRequestReport(selectedStudyRequest)"
        >
          <i
            v-tooltip="$t('hoverBtn.printRequest')"
            class="far fa-print"
            aria-hidden="true"
          />
        </b-button>

        <b-button
          v-if="printEnabled && selectedStudyRequest.status.code !== REQUEST_STATES.DRAFT.code
            && hasLabOperationGlobalMixin(selectedStudyRequest.laboratory.labId,requestOperation.PRINT_REQUEST_AND_LABELS)"
          id="requestFormSubRequestPrintLabels"
          slot="buttons-end"
          v-tooltip="$t('hoverBtn.printLabels')"
          class="btn__icon btn__icon--primary px-2 py-0"
          variant="primary"
          @click="printSubrequestLabels(selectedStudyRequest)"
        >
          <i
            class="far fa-ticket-alt"
            aria-hidden="true"
          />
        </b-button>

        <b-button
          v-if="selectedStudyRequest.status.code !== REQUEST_STATES.DRAFT.code
            && hasLabOperationGlobalMixin(selectedStudyRequest.laboratory.labId, requestOperation.PRINT_REQUEST_AND_LABELS)"
          id="requestFormSubRequestPrintLabelPopover"
          slot="buttons-end"
          v-tooltip="$t('component.studyRequest.subRequestForm.printCustomLabels')"
          class="btn__icon btn__icon--primary px-2 py-0"
          variant="primary"
        >
          <i
            class="icon-ticket-setup"
            aria-hidden="true"
          />
        </b-button>

        <b-button
          v-if="printEnabled && selectedStudyRequest.status.code !== REQUEST_STATES.DRAFT.code
            && hasLabOperationGlobalMixin(selectedStudyRequest.laboratory.labId, requestOperation.PRINT_REQUEST_AND_LABELS)"
          id="requestFormDownloadRequest"
          slot="buttons-end"
          v-tooltip="$t('clinical.grid.viewRequestReport')"
          class="btn__icon btn__icon--primary px-2 py-0"
          variant="primary"
          @click="downloadRequestReportPdf"
        >
          <i
            class="far fa-file-medical"
            aria-hidden="true"
          />
        </b-button>

        <b-button
          v-if="selectedStudyRequest.status.code === REQUEST_STATES.COMPLETED.code && hasLabOperationGlobalMixin(selectedStudyRequest.laboratory.labId, caseOperation.PETITIONER_PRINT)"
          id="requestFormDownloadCase"
          slot="buttons-end"
          v-tooltip="$t('registry.btn.viewAnaReport')"
          class="btn__icon btn__icon--primary px-2 py-0"
          variant="primary"
          @click="downloadCaseAPReportPdf()"
        >
          <i
            class="far fa-file-contract"
            aria-hidden="true"
          />
        </b-button>

        <b-button
          id="requestsSidePanelClose"
          slot="buttons-end"
          v-shortkey="['shift', 'esc']"
          class="btn__icon btn__icon--primary pl-3 pr-0 py-0"
          @shortkey.prevent="showSidePanel = false"
          @click="showSidePanel = false"
        >
          <i
            class="fal fa-times"
            aria-hidden="true"
          />
        </b-button>

        <print-label-popover
          slot="buttons-end"
          target="requestFormSubRequestPrintLabelPopover"
          label-field="surExternalId"
          :elements="selectedStudyRequest.subrequests"
          :lab-id="selectedStudyRequest.laboratory.labId"
          :parent-id="selectedStudyRequest.id"
          @printSelectedLabelsWithCopies="printSelectedSubrequestLabelsWithCopies"
        />
      </study-request-detail>
    </vt-side-panel>
    <b-row class="search-block mb-3 mt-1">
      <b-col
        xl="8"
        lg="9"
        md="12"
        class="d-flex"
      >
        <local-searcher-clinical
          :identifier-options="identifierScopesForSearch"
          :initial-identifier="identifierScopesForSearch[0]"
          @requestSearch="requestSearch"
          @studySearch="studySearch"
          @patientSearch="patientSearch"
        />
      </b-col>
      <b-col
        xl="4"
        lg="3"
        md="12"
        class="text-right"
      >
        <div
          class="mt-1 d-flex align-items-center justify-content-end"
        >
          <b-button
            v-if="hasOperationInAnyLaboratoryGlobalMixin(requestOperation.CREATE)"
            v-shortkey="['alt', 'n']"
            class="ml-3 btn btn--primary btn-secondary btn-sm"
            @shortkey.prevent="createRequest(patientInformation.patId)"
            @click="createRequest(patientInformation.patId)"
          >
            <fa-icon
              class="mr-1"
              :icon="['fal', 'plus']"
            />
            {{ $t('clinical.btn.requestPatient') }}
          </b-button>
          <b-button
            v-tooltip="$t('global.newRequest')"
            class="btn__icon btn__icon--primary px-3"
            @click="$refs.clinicalSearchModal.show()"
          >
            <span class="far fa-file-medical" />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <patient-card
          v-if="patientInformation"
          :patient="patientInformation"
          @openPatientModal="$refs.modalPatientCard.show()"
        />
      </b-col>
    </b-row>
    <div class="grid-container mt-3">
      <GridHeader
        v-if="gridApi"
        :gridtitle="rowData.length + ' ' + $tc('global.request', rowData.length)"
      >
        <div class="pl-1 pr-0 d-flex align-items-center">
          <button
            id="samplesCleanFilters"
            v-tooltip="$t('global.cleanFilter')"
            v-shortkey="['ctrl', 'alt', 'f']"
            type="button"
            class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
            @shortkey.prevent="cleanFilters"
            @click="cleanFilters"
          >
            <i
              class="far fa-filter"
              aria-hidden="true"
            />
          </button>
        </div>
        <div class="pl-1 pr-0 d-flex align-items-center">
          <button
            v-tooltip="$t('global.export')"
            type="button"
            class="btn btn__icon btn__icon--primary mx-2 p-0 btn-secondary"
          >
            <i
              class="far fa-file-export"
              aria-hidden="true"
            />
          </button>
        </div>
      </GridHeader>
      <vt-grid
        class="request-patient-grid"
        :grid-options="gridOptions"
        :row-data="rowData"
        :column-defs="columnDefs"
      />
    </div>
    <modal-wrapper ref="modalPatientCard">
      <modal-patient-card
        v-if="patientInformation"
        id="modalPatientCard"
        :patient-id="patientId"
      />
    </modal-wrapper>
    <modal-wrapper ref="clinicalSearchModal">
      <clinical-search-patient-modal
        id-modal="clinicalSearchModal"
        @patientSelectedCreateRequest="createRequest($event)"
        @patientSelected="createRequest($event)"
      />
    </modal-wrapper>
    <modal-confirmation
      id="confirmationModalCheckableClinical"
      ref="confirmationModal"
      :content="modalConfirmationMessage"
      :store-name="storeNameModal"
      :ui-component="uiComponentModal"
      :name="nameModal"
    />
    <modal-wrapper ref="addFileModalWrapper">
      <add-file-modal
        id="addFileModal"
        ref="addFileModal"
        :request-created="true"
        :attachment-entity-type="ATTACHMENT_ENTITY_TYPE"
        :entities-id-array="entitiesIdArray"
        @attachmentsAdded="reloadRowData"
      />
    </modal-wrapper>
    <print-component ref="printComponent" />
  </div>
</template>

<script>
import ModalConfirmation from '@/components/modals/ModalConfirmationCheckable'
import AddFileModal from '@/components/AddFileModal'
import PatientCard from '@/modules/clinicalModule/components/PatientCard'
import VtGrid from '@/components/VtGrid/VtGrid'
import GridHeader from '@/components/GridHeader'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import { clinicalGridColumnDefs } from '@/modules/clinicalModule/views/grid/clinical-grid.column-defs'
import PatientResource from '@/api/resources/PatientResource'
import clinicalRequestService from '@/modules/clinicalModule/services/clinicalRequestService'
import Encoder from '@/utils/encoder'
import ModalPatientCard from '@/components/modals/ModalPatientCard'
import LocalSearcherClinical from '@/components/SearcherModuleEntitySelection'
import { RequestOperation } from '@/api/operations/models/request-operation'
import { CaseOperation } from '@/api/operations/models/case-operation'
import { REQUEST_STATES } from '@/api/resources/entityState/request-state'
import ClinicalSearchPatientModal from '@/modules/clinicalModule/components/clinical-search-patient-modal/ClinicalSearchPatientModal'
import clinicalGridContextMenuMixin from '@/modules/clinicalModule/mixins/clinicalGridContextMenuMixin'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { PATIENT_IDENTIFIER } from '@/api/resources/identifierScopesResource'
import StudyRequestDetail from '@/components/common/detail/CommonRequestDetail'
import commonRequestService from '@/api/resources/common/commonRequestService'
import clinicalRequestPrintService from '@/modules/printModule/services/ClinicalRequestPrintService'
import clinicalCasePrintService from '@/modules/printModule/services/ClinicalCasePrintService'
import PrintLabelPopover from '@/modules/clinicalModule/components/Popover/PrintLabelPopover'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'
import { IdentifierTypeScope } from '@/api/resources/common/initialization/common-initialization.dto'

export default {
    name: 'ClinicalPatientDetail',
    components: {
        PatientCard,
        VtGrid,
        GridHeader,
        ModalPatientCard,
        LocalSearcherClinical,
        ClinicalSearchPatientModal,
        AddFileModal,
        ModalConfirmation,
        StudyRequestDetail,
        PrintLabelPopover
    },
    mixins: [clinicalGridContextMenuMixin],
    data() {
        return {
            caseOperation: CaseOperation,
            requestOperation: RequestOperation,
            REQUEST_STATES: REQUEST_STATES,
            ATTACHMENT_ENTITY_TYPE: ATTACHMENT_ENTITY_TYPE,
            hideBtn: false,
            patientId: null,
            encoder: new Encoder(),
            patientInformation: null,
            columnDefs: clinicalGridColumnDefs(params => this.onIdCellClicked(params), true),
            gridApi: null,
            rowData: [],
            storeNameModal: 'clinicalModalsState',
            uiComponentModal: 'uicomponent.petitioner.modalconfig',
            uiComponentGrid: 'uicomponent.petitioner.requestgrid',
            nameModal: null,
            modalConfirmationMessage: '',
            modalConfirmationCheckMessage: '',
            entitiesIdArray: [],
            preventClick: false,
            showSidePanel: false,
            selectedStudyRequest: null,
            reqCasId: null,
            delayDoubleClick: 200
        }
    },
    computed: {
        identifierScopesForSearch() {
            return [
                { scopes: [IdentifierTypeScope.CENTER_PATIENT, IdentifierTypeScope.PERSON], icon: 'fal fa-user-circle', text: this.$t('component.searcher.patient'), id: PATIENT_IDENTIFIER },
                { scopes: [IdentifierTypeScope.REQUEST], icon: 'fal fa-file-medical', text: this.$tc('global.request', 1), errorMessage: this.$t('clinical.error.validIdentifierRequest') },
                { scopes: [IdentifierTypeScope.CASE], icon: 'fal fa-chart-network', text: this.$tc('global.case', 1), errorMessage: this.$t('clinical.error.validIdentifierCase') }
            ]
        },
        printEnabled() {
            return this.$_hasLabOperation(this.selectedStudyRequest.laboratory.labId, 'operation.entity.request.printrequestandlabels')
        },
        gridOptions() {
            return {
                pagination: false,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                getContextMenuItems: this.getContextMenuItems,
                onRowDoubleClicked: this.onRowDoubleClicked,
                floatingFilter: false,
                sideBar: gridSideBarConfig,
                onGridReady: this.onGridReady
            }
        }
    },
    created() {
        this.patientId = this.$route.params.id
        this.getPatientInformation()
        this.getRequests()
    },
    methods: {
        onIdCellClicked({ data: studyRequest }) {
            setTimeout(async () => {
                if (!this.preventClick) {
                    this.reqCasId = studyRequest?.caseStudy?.casId

                    const isSame = this.selectedStudyRequest && studyRequest.id === this.selectedStudyRequest.id
                    if (isSame) {
                        this.showSidePanel = !this.showSidePanel
                    } else {
                        const response =
                            await this.$_toCallUnique(
                                commonRequestService.getRequestByIdForSidePanel(
                                    studyRequest.laboratory.labId,
                                    studyRequest.id))
                        if (response) {
                            this.selectedStudyRequest = null
                            this.$nextTick(() => (this.selectedStudyRequest = response))
                            this.showSidePanel = true
                        }
                    }
                }
            }, this.delayDoubleClick)
        },
        onRowDoubleClicked({ data }) {
            this.preventClick = true
            this.$router.push({
                name: 'editRequest',
                params: {
                    requestId: data.id,
                    labId: data.laboratory.labId,
                    patientDetail: true,
                    showBackButton: true
                }
            })
        },
        async downloadRequestReportPdf() {
            const blob =
                await this.$_toCallUnique(
                    clinicalRequestPrintService.downloadRequestReportPdf(
                        [this.selectedStudyRequest.id]))
            if (blob) {
                const newWindowTabTitle = `${this.selectedStudyRequest.label} - ${this.$tc('global.report')}`
                const openFileParams = {
                    blob,
                    newWindowTabTitle
                }
                this.$_openFile(openFileParams)
            }
        },
        async downloadCaseAPReportPdf() {
            const blob =
                await this.$_toCallUnique(
                    clinicalCasePrintService.downloadCaseAPReportPdf(
                        this.selectedStudyRequest.laboratory.labId,
                        this.reqCasId,
                        false))
            if (blob) {
                this.$emit('loadSummary')
                const openFileParams = {
                    blob,
                    newWindowTabTitle: `${this.selectedStudyRequest.caseLabel} - ${this.$tc('global.report')}`
                }
                this.$_openFile(openFileParams)
            }
        },
        async requestSearch(search) {
            const response =
                await this.$_toCallUnique(
                    clinicalRequestService.searchRequestByLabel(search),
                    error => this.$_showErrorModal(
                        error?.response?.data?.code === this.$apiExceptions.ENTITY_NOT_FOUND
                            ? this.$tc('component.searcher.error.noRequest')
                            : undefined))
            if (response) {
                await this.$router.push({
                    name: 'editRequest',
                    params: {
                        requestId: response.requestId,
                        labId: response.laboratoryId
                    }
                })
            }
        },
        async patientSearch(searchInformation) {
            const params = {
                size: PAGINATOR_BIG_PAGE_SIZE,
                id: searchInformation.identifierSearch,
                surname1: searchInformation.patientSurname1Search,
                surname2: searchInformation.patientSurmname2Search,
                middleName: searchInformation.patientMiddlenameSearch,
                name: searchInformation.patientNameSearch,
                centerCode: searchInformation.center,
                identifierType: searchInformation.type
            }
            const response =
                await this.$_toCallUnique(
                    PatientResource.paginator(params),
                    error => this.$_showErrorModal(
                        error?.response?.data?.code === this.$apiExceptions.RESULT_LIMIT_EXCEEDED
                            ? this.$tc('component.patient.searcher.tooManySearchResults')
                            : undefined))
            if (response) {
                const patients = response.content
                if (!patients.length && searchInformation.identifierSearch) {
                    this.$_showErrorModal(
                        this.$tc('component.patient.searcher.noResultsWithIdentifier',
                            { identifier: searchInformation.identifierName }))
                } else if (!patients.length) {
                    this.$_showErrorModal(this.$tc('component.patient.searcher.noResults'))
                } else if (patients.length === 1) {
                    await this.$router.push({
                        name: 'clinicalPatientDetail',
                        params: {
                            id: patients[0].patId
                        }
                    })

                    this.patientId = patients[0].patId
                    await this.getPatientInformation()
                    await this.getRequests()
                } else {
                    await this.$router.push({
                        name: 'clinicalPatientGrid',
                        params: {
                            patients
                        }
                    })
                }
            }
        },
        async studySearch(searchInformation) {
            const response =
                await this.$_toCallUnique(
                    clinicalRequestService.searchRequestByCaseNumber(searchInformation),
                    error => this.$_showErrorModal(
                        error?.response?.data?.code === this.$apiExceptions.ENTITY_NOT_FOUND
                            ? this.$tc('component.searcher.error.noCase')
                            : undefined))
            if (response) {
                await this.$router.push({
                    name: 'editRequest',
                    params: {
                        requestId: response.requestId,
                        labId: response.laboratoryId
                    }
                })
            }
        },
        cleanFilters() {
            this.gridApi.setFilterModel(null)
        },
        async getRequests() {
            const params = {
                size: PAGINATOR_BIG_PAGE_SIZE
            }
            const response =
                await this.$_toCallSecure(
                    clinicalRequestService.paginator(
                        null,
                        params,
                        `/clinical/laboratories/patients/${this.patientId}/requests/previous`))
            if (response) {
                this.rowData = response.content
            }
            return []
        },
        async reloadRowData() {
            await this.getRequests()
        },
        async getPatientInformation() {
            const response =
                await this.$_toCallSecure(
                    PatientResource.findById(this.patientId))
            if (response) {
                this.patientInformation = response
            }
        },
        onGridReady({ api }) {
            this.gridApi = api

            this.gridApi.setColumnDefs(
                this.$_filterPatientColumns(
                    this.columnDefs,
                    'patient.middleName',
                    'patient.surname2'))
            api.sizeColumnsToFit()
        },
        async createRequest(patId) {
            const response =
                await this.$_toCallSecure(
                    PatientResource.findById(patId))
            if (response) {
                await this.$router.push({
                    name: 'newRequest',
                    params: {
                        initPatient: response
                    }
                })
            }
        },
        printSelectedSubrequestLabelsWithCopies(elementsWithCopies) {
            this.$refs.printComponent?.printSubrequestReportFromClinical(
                this.selectedStudyRequest.laboratory.labId,
                this.selectedStudyRequest.id,
                elementsWithCopies)
        }
    }
}
</script>

<style scoped>
    .request-patient-grid {
        width: 100%;
        height: 100%;
    }
</style>
